module.exports = "./app-dist/templates/header-main-search.controller.9cd61f583a304609fdba9545b23597a4.html";